import { BaseModel } from "sjs-base-model";
import IsinModel from "./IsinModel";

export default class SingleIsinReportShortModel extends BaseModel {
    id = 0;
    date = 0;
    isins = [IsinModel];
    created = "";
    price = 0.0; // subtotal
    discount = 0.0;
    totalPrice = 0.0;
    state = "";
    reportLink = null;

    constructor(data) {
        super();
        this.update(data);
    }
}
